import React, { useState, useRef } from 'react';
import styled from 'styled-components/macro';
import { Button } from '@material-ui/core';
import { useOutsideAlerter } from '../../custom-hooks';
import { Add as AddIcon } from '@material-ui/icons';
import { curBookingsActions } from '../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { canEditTicketSelector } from '../../store/selectors/ticket.selector';

interface AddMultipleRowProps {
  isSelectedAll: boolean;
  setIsSelectedAll: (val: boolean) => void;
}

const MAX_ROWS_TO_ADD = 100;

const AddMultipleRow: React.FC<AddMultipleRowProps> = ({
  isSelectedAll,
  setIsSelectedAll,
}) => {
  const dispatch = useDispatch();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const canEdit = useSelector(canEditTicketSelector);
  useOutsideAlerter(dropdownRef, () => {
    setShowDropdown(false);
  });
  const [inputValue, setInputValue] = useState(0);
  const handleShowDropDown = () => {
    setShowDropdown(!showDropdown);
  };
  /**
   * add multiple rows
   */
  const handleClickAddMultiple = () => {
    const newBookingsM = dispatch(
      curBookingsActions.addMultipleBookings(
        inputValue,
        false,
        isSelectedAll,
      ),
    );
    setIsSelectedAll(newBookingsM.isAllSelected());
    // close the dropdown panel
    setShowDropdown(false);
  };
  const handleOnValueChange = (e) => {
    const value = e.target.value;
    if (value >= 1 && value <= MAX_ROWS_TO_ADD) {
      setInputValue(e.target.value);
    }
  };
  return (
    <SAddMultipleRow ref={dropdownRef}>
      <SButton
        color="primary"
        variant="contained"
        onClick={() => handleShowDropDown()}
        startIcon={<AddIcon />}
        disabled={!canEdit}
      >
        Add Multiple Rows
      </SButton>
      {showDropdown && (
        <SDropdown>
          Rows
          <SInput
            type="number"
            autoFocus
            onChange={handleOnValueChange}
            max={MAX_ROWS_TO_ADD}
            placeholder={`Enter a number between 1-${MAX_ROWS_TO_ADD}`}
            min={1}
          />
          <SButtonGroup>
            <SCancel onClick={() => handleShowDropDown()}>
              Cancel
            </SCancel>
            <SSubmit
              color="primary"
              variant="contained"
              onClick={() => handleClickAddMultiple()}
            >
              Submit
            </SSubmit>
          </SButtonGroup>
        </SDropdown>
      )}
    </SAddMultipleRow>
  );
};

export default AddMultipleRow;
const SButtonGroup = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
`;
const SSubmit = styled(Button)`
  color: ${(props) => props.theme.palette.common.white};
  background: #b73f83;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.27);
  border-radius: 9px;
  width: 108px;
  height: 38px;

  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
const SCancel = styled.div`
  cursor: pointer;
`;
const SInput = styled.input`
  width: 223px;
  background: ${(props) => props.theme.palette.common.white};
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.17);
  border-radius: 6px;
  border: none;
  height: 46px;
  padding: 0 0 0 10px;
`;
const SDropdown = styled.div`
  font-weight: 500;
  display: flex;
  justify-content: space-evenly;
  padding: 1rem;
  font-size: 16px;
  color: #b73f83;
  background: ${(props) => props.theme.palette.common.white};
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
  border-radius: 0.5rem;
  width: 275px;
  height: 165px;
  position: absolute;
  z-index: 2;
  right: -5px;
  top: 54px;
  display: flex;
  flex-direction: column;
`;
const SAddMultipleRow = styled.div`
  position: relative;
`;
const SButton = styled(Button)`
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.27);
  border-radius: 6px;
  width: 198px;
  height: 50px;
  color: ${(props) => props.theme.palette.common.white};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
